import { Socials } from '../Socials';
import * as styles from './styles.css';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';

export const Header: React.FC = () => {
  return (
    <div className={styles['container']}>
      <CianLogoSign />
      <Socials theme="white" />
    </div>
  );
};
